// Messello — keeps the public demo workspace session ephemeral.
//
// Normal logins persist across tab close (devise-token-auth cookie) so users
// return straight to their cabinet. The shared, read-only demo must NOT behave
// that way: "зашёл-посмотрел-закрыл" — the visitor should never be silently
// re-authenticated into the demo dashboard, and clicking "Log in" must show the
// real login form instead of bouncing into the demo.
//
// Two markers drive this:
//   ACTIVE_KEY (localStorage)  — the current auth cookie belongs to the demo.
//                                Persists across reloads; cleared once a real
//                                login takes over or the demo is dropped.
//   TAB_KEY    (sessionStorage) — this browser tab is the one that opened the
//                                demo. Cleared automatically when the tab/window
//                                closes, which is what makes the session
//                                ephemeral across reopens and new tabs.
const ACTIVE_KEY = 'mzDemoActive';
const TAB_KEY = 'mzDemoTab';

export const markDemoSession = () => {
  try {
    window.localStorage.setItem(ACTIVE_KEY, '1');
    window.sessionStorage.setItem(TAB_KEY, '1');
  } catch (e) {
    // storage unavailable (private mode / disabled) — nothing to do
  }
};

export const isDemoCookieSession = () => {
  try {
    return window.localStorage.getItem(ACTIVE_KEY) === '1';
  } catch (e) {
    return false;
  }
};

export const isDemoOpenedInThisTab = () => {
  try {
    return window.sessionStorage.getItem(TAB_KEY) === '1';
  } catch (e) {
    return false;
  }
};

export const clearDemoSession = () => {
  try {
    window.localStorage.removeItem(ACTIVE_KEY);
    window.sessionStorage.removeItem(TAB_KEY);
  } catch (e) {
    // ignore
  }
};

// The demo entry redirect carries ?demo=1 on the SSO login URL.
export const isDemoEntryURL = () => {
  try {
    return new URLSearchParams(window.location.search).get('demo') === '1';
  } catch (e) {
    return false;
  }
};
